<template>
  <!-- BEGIN pos-counter-content -->
  <div class="ts-p-6">
    <div class="ts-space-y-4">
      <label
        class="col-form-label ts-mb-3 ts-font-bold ts-w-full ts-px-2 bg-success ts-flex ts-justify-items-center ts-items-center"
        style="height: 45px;">
        <i class="fa fa-id-card fa-fw fa-lg ts-pb-1" style="color: white;"></i>
        <h4 style="margin: 0 !important;color: white;" class="ts-pl-2">{{ $t('restaurantSale.memberCard') }}</h4>
      </label>
      <div v-if="selectedMemberCard" class="member-card-info">
        <div class="card-header">
          <div class="customer-name">{{ selectedMemberCard.customer_name || $t('customerMemberCard.unassignedCard') }}</div>
          <div class="customer-name">#{{ selectedMemberCard.serial_card }}</div>
        </div>
        <div class="card-info">
          <div class="info-item">
            <div class="info-label">{{ $t('restaurantSale.contactNumber') }}</div>
            <div class="info-value">{{ selectedMemberCard.contact_number || 'N/A' }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">{{ $t('restaurantSale.maxTime') }}</div>
            <div class="info-value">{{ selectedMemberCard.used_times }} / {{ selectedMemberCard.max_times }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">{{ $t('restaurantSale.availableTime') }}</div>
            <div class="info-value">{{ selectedMemberCard.available_times }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">{{ $t('restaurantSale.expiryDate') }}</div>
            <div class="info-value">{{ selectedMemberCard.expiry_date || 'N/A' }}</div>
          </div>
          <div class="info-item" v-if="selectedMemberCard.package_promotion">
            <div class="info-label">{{ $t('customerMemberCard.package') }}</div>
            <div class="info-value">{{ selectedMemberCard.package_promotion.package_name }}</div>
          </div>
        </div>
      </div>
      <div class="ts-border-t ts-border-gray-300 ts-pt-4">
        <div class="pos pos-counter">
          <div class="pos-counter-body">
            <div class="pos-counter-content">
              <vue-custom-scrollbar class="pos-counter-content-container">
                <ts-loading-banner :loading="false">
                  <div class="table-row">
                    <TableCard v-for="(table, index) in tableLists" :key="index" :table="table"
                      :selected="checkSelected(table)" @click="onTableSelected(table)" />
                  </div>
                </ts-loading-banner>
              </vue-custom-scrollbar>
            </div>
          </div>
        </div>
        <div class="ts-py-1">
          <i>
            <span class="ts-text-xs">
              {{ $t('restaurantSale.selectOrScanKey') }}
            </span>
          </i>
        </div>
      </div>
      <div class="btn-row ts-space-x-2 ts-text-right ts-border-t ts-border-gray-300 ts-pt-4">
        <ts-button @click.prevent="$emit('cancel')"><i class="fa fa-arrow-left fa-fw fa-lg"></i>
          {{ $t('restaurantSale.back') }}</ts-button>
      </div>
    </div>
  </div>
  <!-- END pos-counter-content -->
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
import RecieptPreview from './reciept-preview'
import TableCard from './MemberCardTableCard.vue'

export default {
  props: ['tableSelected', 'ref_customer_member_card_id'],
  name: 'linkedKeys',
  components: {
    RecieptPreview,
    TableCard
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      model: {
        table_id: null,
        stock_out_id: null,
        linked_keys: [],
      },
      waiting: false,
      isScanning: false,
    }
  },
  created() { },
  computed: {
    tableLists() {
      return _.sortBy(this.$store.state.restaurantSale.counterCheckout.tables, [
        'display_order'
      ])
        .filter(table => table.status_id == 1 && table.guest_level_id == 1)
    },
    customerMemberCards() {
      return this.$store.state.restaurantSale.counterCheckout.customer_member_cards
    },
    selectedMemberCard() {
      return this.customerMemberCards.find(el => el.customer_member_card_id == this.ref_customer_member_card_id)
    },
  },
  methods: {
    checkSelected(table) {
      const selected = this.model.linked_keys.find(el => el.table_id == table.table_id)
      return selected ? true : false
    },
    onTableSelected(table) {
      table.ref_customer_member_card_id = this.ref_customer_member_card_id
      table.pre_charge_payment_method = 5

      let packagePromotion = this.customerMemberCards.find(el => el.customer_member_card_id == this.ref_customer_member_card_id)

      table = {
        ...table,
        checking_type: packagePromotion.promotion_type_id,
        pre_charge_bank_id: null,
        pre_charge_bank_account_number: null,
        invoice_detail: packagePromotion ? packagePromotion.package_promotion.details.map(el => ({
          amount: el.sub_total,
          discount_amount: el.discount_amount,
          discount_rate: el.discount_rate,
          discount_type: el.discount_type,
          grand_total: el.grand_total,
          is_allow_adjust_free_quantity: false,
          is_pre_charge: true,
          max_person: null,
          product_id: el.product_id,
          promo_free_item_cond_id: null,
          promo_type_id: null,
          quantity: el.quantity,
          remarks: null,
          service_length: el.service_length,
          total_after_discount: el.grand_total,
          unit_price: el.unit_price,
          uom_id: el.uom_id,
          vat_amount: el.vat_amount,
          vat_rate: el.vat_rate,
        })) : [],
      }

      this.$emit('onTableSelected', table)
    },
  }
}
</script>
<style scoped lang="scss">
.member-card-info {
  font-family: 'Segoe UI';
  border-radius: 4px;
  margin-bottom: 12px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  padding: 8px 15px;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-radius: 4px 4px 0 0;
  background-color: #00acac;
}

.customer-name {
  font-size: 16px;
  font-weight: 600;
  color: white;
  white-space: nowrap;
}

.card-info {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 5px;
  background: #f2f3f4;
  padding: 5px 15px 10px 15px;
  border-radius: 0 0 4px 4px;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-bottom: 1px solid black;

  @media (max-width: 54em) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.info-item {
  display: flex;
  flex-direction: column;
}

.info-label {
  font-size: 0.65rem;
  color: #666;
  margin-bottom: 0px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.info-value {
  font-size: 0.85rem;
  color: #333;
  font-weight: 500;
  white-space: nowrap;
}

.pos-counter {
  padding-top: 0;
  height: 400px !important;

  @media (max-width: 75em) {
    height: 400px !important;
  }

  @media (max-width: 54em) {
    height: 400px !important;
  }

  @media (max-width: 37.5em) {
    height: 350px !important;
  }
}

@media (max-width: 991.98px) {

  .pos-counter .pos-counter-header .logo,
  .time,
  .nav .nav-item {
    display: none;
  }

}
</style>
<style>
.ant-notification {
  z-index: 1030;
}
</style>